import PersonalDetails from './PersonalDetailsContainer';

export default PersonalDetails;